import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { AlertSnackbarContext } from '../../../components/snackbars';
import { Media } from '../../../types/Media';
import Api from '../../api/api';

export type AnnouncementUpdateDTO = {
  title: string;
  published: boolean;
  media: Media;
};

export const updateAnnouncement = async (id: string, params: AnnouncementUpdateDTO) => {
  const [response, bodyOrError] = await Api.patch(`announcement/${id}`, params);

  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useUpdateAnnouncement = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation(
    'updateAnnouncement',
    (data: { id: string; params: AnnouncementUpdateDTO }) => {
      return updateAnnouncement(data.id, data.params);
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries(['getAnnouncement']);
        queryClient.invalidateQueries(['getAnnouncementsByPage']);
        setAlertSnackbar({
          message: `${data.title} updated successfully.`,
          severity: 'success',
          vertical: 'top',
        });
        navigate('/cms/announcements');
      },
    },
  );
};
